<template>
    <vue-headful
        :title="fullTitle"
    />
</template>

<script>
// Wrapper around Vue-headful, because we always want to append the app title.
export default {
    name: "Headful",
    props: {
        title: {
            type: String
        }
    },
    computed: {
        fullTitle () {
            return (this.title ? (this.title + ' - ') : '') + process.env.POrtaal Passievooronderwijs;
        }
    }
}
</script>

<style scoped>

</style>
